module.exports = __webpack_public_path__ + "img/black_cloud.6fdc525e.gif";